import { render, staticRenderFns } from "./DuplicateActionDialogComponent.vue?vue&type=template&id=63cec3f0&scoped=true"
import script from "./DuplicateActionDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DuplicateActionDialogComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DuplicateActionDialogComponent.vue?vue&type=style&index=0&id=63cec3f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cec3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cec3f0')) {
      api.createRecord('63cec3f0', component.options)
    } else {
      api.reload('63cec3f0', component.options)
    }
    module.hot.accept("./DuplicateActionDialogComponent.vue?vue&type=template&id=63cec3f0&scoped=true", function () {
      api.rerender('63cec3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/DuplicateActionDialogComponent.vue"
export default component.exports